export default __webpack_public_path__ + "static/media/027-moai.33699852.svg";